module.exports = __webpack_public_path__ + "static/img/beer.b9c5726.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo/beer.png
// module id = 807
// module chunks = 1